import DeleteIcon from '@mui/icons-material/Delete';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { Grid, TextField, Typography } from '@mui/material';
import { type MRT_ColumnDef } from 'material-react-table';
import { useCallback, useMemo, useState } from 'react';

import {
  SampleTable,
  SingleButton,
  SingleIconButton,
} from '@/shared/components/ui';
import { AlertSeverityEnum, MaterialTransferido } from '@/shared/interfaces';
// import { IUbicacionProducto } from '@/shared/interfaces/erp/inventario';
import { MaterialesKey, useMaterialesUtilizadosStore } from '@/store/erp';
import { useUiStore } from '@/store/ui';
import { ProductUbicacionSeriesModal } from './modals';
import EquiposDisponiblesOTTecModal from './modals/EquiposDisponiblesOTTecModal';
import { gridSizeMdLg12, gridSizeMdLg6 } from '@/shared';
import ModalUbicacionProductoSelectComponente from '@/erp/inventario/ingreso-producto/shared/componente/ModalUbProductoSelectComponente';

export type EquiposUtilizadosInstallOTTecAsigProps = {
  control?: any;
  ubicacion?: string;
};

export type EquiposUtilizadosOTTableType = MaterialTransferido
// {
//   id?: number; // ? - id_ubicaion_producto
//   cantidadUtilizada: number;

//   contieneSeries: boolean;
//   selectedSeries: string[];
//   allSeries: string[];
//   savedSeries: string[];
//   selectedSeriesData: string[];

//   // correctin OT
//   isCorrectingOT?: boolean;

//   // firbra & bobina
//   isFibraBobina?: boolean;
//   isUTP?: boolean;
//   puntaInicio?: number;
//   puntaFinal?: number;

//   //
// };

const EquiposUtilizadosInstallOTTecAsig: React.FC<
  EquiposUtilizadosInstallOTTecAsigProps
> = ({
  control,
  ubicacion,
}) => {
    ///* local state -----------------------
    const [openSeriesModal, setOpenSeriesModal] = useState(false);
    const [openEquiposAsignadosModal, setOpenEquiposAsignadosModal] =
      useState(false);

    ///* global state -----------------------
    const equipos_utilizados = useMaterialesUtilizadosStore(
      s => s.equipos_utilizados
    );
    const setActiveItemRow = useMaterialesUtilizadosStore(
      s => s.setActiveItemRow
    );
    const updateSelectedItemQuantity = useMaterialesUtilizadosStore(
      s => s.updateSelectedItemQuantity
    );
    const removeSelectedItem = useMaterialesUtilizadosStore(
      s => s.removeSelectedItem
    );
    const addSelectedItemProducto = useMaterialesUtilizadosStore(
      s => s.addSelectedItemProducto
    );

    const setAlert = useUiStore(s => s.setAlert);

    ///* handlers -----------------------
    const onChangeQuantity = useCallback(
      (value: any, item: any) => {
        const stockActual = item?.stock_actual || 0;

        if (+value > +stockActual) {
          setAlert(
            true,
            `La cantidad máxima permitida es ${stockActual}`,
            AlertSeverityEnum.error
          );
          return;
        }

        updateSelectedItemQuantity(
          {
            ...item,
            cantidadUtilizada: +value,
            cantidad: +value,

            // reset series when quantity is changed
            selected_series: [],
            selectedSeries: [],
            savedSeries: [],
          },
          MaterialesKey.equipos_utilizados,
          'id'
        );
      },
      [updateSelectedItemQuantity]
    );
    const onChangeSeries = useCallback(
      (value: any, item: any) => {
        updateSelectedItemQuantity(
          { ...item, selected_series: value },
          MaterialesKey.equipos_utilizados,
          'id'
        );
      },
      [updateSelectedItemQuantity]
    );

    ///* colums -----------------------
    const columns = useMemo<MRT_ColumnDef<EquiposUtilizadosOTTableType>[]>(
      () => [
        {
          accessorKey: 'codigo',
          header: 'Código',
          Cell: ({ row }) => row.original?.producto_data?.codigo || 'N/A',
        },
        {
          accessorKey: 'descripcion',
          header: 'Descripción',
          Cell: ({ row }) => row.original?.producto_data?.descripcion || 'N/A',
        },

        {
          accessorKey: 'stock_actual',
          header: 'Stock Actual',
          // stock_actual = cantidad transferida
          Cell: ({ row }) => row.original?.stock_actual ?? '0',
        },

        {
          accessorKey: 'cantidad',
          header: 'Cantidad Utilizada',
          Cell: ({ row }) => {
            // const isCorrectingOT = row.original?.cantidad;

            // // direct access to avoid reference issues ----
            // const equiposAdicionales =
            //   useMaterialesUtilizadosStore.getState().equiposAdicionalesPreventa;
            // // check if item is in equiposAdicionales ----
            // const isItemInEquiposAdicionales = equiposAdicionales.some(
            //   e => e?.codigo === row.original?.producto_data?.codigo
            // );

            // const isNecesaryBlockAction =
            //   isCorrectingOT; /* && isItemInEquiposAdicionales */

            return (
              <TextField
                variant="outlined"
                value={
                  row.original?.producto_data?.es_ont ?
                    1
                    :
                    (row.original?.cantidad?.toString() || '')}
                onChange={e => {
                  // prevent change quantity if is in equiposAdicionales and is correcting OT
                  // if (isNecesaryBlockAction) {
                  //   setAlert(
                  //     true,
                  //     isCorrectingOT
                  //       ? 'No se puede modificar la cantidad de un equipo adicional en corrección de datos.'
                  //       : 'Modificación de cantidad no permitida.',
                  //     AlertSeverityEnum.error
                  //   );
                  //   return;
                  // }
                  onChangeQuantity(e.target.value, {
                    ...row.original,
                    id: row.original.id,
                  });
                }}
                type="number"
                inputProps={{
                  min: 0,
                  max: row.original?.stock_actual || 0,
                  step: 1,
                }}
              // disabled={isNecesaryBlockAction}
              />
            );
          },
        },

        {
          accessorKey: 'modelo',
          header: 'Modelo',
          Cell: ({ row }) =>
            row.original?.producto_data?.modelo_producto || 'N/A',
        },
        {
          accessorKey: 'marca_producto',
          header: 'Marca',
          Cell: ({ row }) => row.original?.producto_data?.marca_producto || 'N/A',
        },

        {
          accessorKey: 'selected_series',
          header: 'Series Seleccionadas',
          Cell: ({ row }) => {
            return !row.original?.contiene_serie ?
              'SIN SERIES'
              : row.original?.selected_series ?
                row.original?.selected_series?.length
                : 0;
          },
        },
        {
          accessorKey: 'series',
          header: 'Series Disponibles',
          Cell: ({ row }) => {
            const hasSeries = row.original?.contiene_serie;

            return hasSeries ? (
              <>
                <SingleIconButton
                  startIcon={<QrCode2Icon />}
                  color="info"
                  label="Ver Series"
                  onClick={() => {
                    setOpenSeriesModal(true);

                    const selectedSeries = row.original?.selected_series || [];
                    setActiveItemRow({
                      ...row.original,
                      selectedSeries,
                    });

                    // set series to product in table
                    onChangeSeries(selectedSeries, row.original);
                  }}
                />
              </>
            ) : (
              <>SIN SERIES</>
            );
          },
        },

        {
          accessorKey: 'remove',
          header: 'Eliminar',
          Cell: ({ row }) => {
            // const isCorrectingOT = row.original?.isCorrectingOT;
            // // direct access to avoid reference issues ---
            // const equiposAdicionales =
            //   useMaterialesUtilizadosStore.getState().equiposAdicionalesPreventa;

            // // check if item is in equiposAdicionales ---
            // const isItemInEquiposAdicionales = equiposAdicionales.some(
            //   e => e?.codigo === row.original?.producto_data?.codigo
            // );

            // if (/*isItemInEquiposAdicionales &&*/ isCorrectingOT) return null;

            return (
              <SingleButton
                newCustomButton
                iconButton
                color="error"
                startIcon={<DeleteIcon />}
                onClick={() => {
                  removeSelectedItem(
                    row.original?.id!,
                    MaterialesKey.equipos_utilizados,
                    'id'
                  );
                }}
              />
            );
          },
        },
      ],
      [onChangeQuantity, removeSelectedItem]
    );

    return (
      <>
        {/* <TabTextLabel text="EQUIPOS UTILIZADOS" pt="48px" /> */}

        <Grid item container spacing={4}>
          <Grid item container xs={12} alignSelf="flex-end">
            <Grid {...gridSizeMdLg12} container item>
              <Grid container item {...gridSizeMdLg6} alignItems={"center"}>
                <Typography variant="body1" fontWeight={700}>Equipos Utilizados</Typography>
              </Grid>
              <Grid container item {...gridSizeMdLg6} alignItems={"center"} justifyContent={"end"}>
                <ModalUbicacionProductoSelectComponente
                  control={control}
                  onChange={(val) => {
                    const aux: MaterialTransferido = {
                      id: val.id_producto,
                      cantidad: 1,
                      codigo: val.codigo,
                      series: val.series,
                      contiene_serie: val.contiene_serie,
                      stock_actual: val.stock_actual,
                      producto_data: {
                        categoria_producto: val.categoria_producto,
                        codigo: val.codigo,
                        descripcion: val.descripcion,
                        stock_actual: val.stock_actual,
                        subcategoria_producto: val.subcategoria_producto,
                        es_ont: true,//val.es_ont
                      },
                      usa_metros: val.usa_metros,
                      metros_actuales: val.metros_actuales,
                    }
                    addSelectedItemProducto(aux, MaterialesKey.equipos_utilizados)
                  }}
                  ubicacion={ubicacion!}
                />
              </Grid>
            </Grid>

            {/* <SingleButton
            newCustomButton
            justifyContent="flex-end"
            label="AGREGAR EQUIPO"
            variant="text"
            onClick={() => {
              setOpenEquiposAsignadosModal(true);
            }}
          /> */}
          </Grid>

          <Grid item xs={12}>
            <SampleTable<EquiposUtilizadosOTTableType>
              columns={columns}
              data={equipos_utilizados}
            />
          </Grid>

          {/* --------------- MODALS --------------- */}
          {/* ------ Equipos Disponible ------ */}
          <EquiposDisponiblesOTTecModal
            open={openEquiposAsignadosModal}
            setOpen={setOpenEquiposAsignadosModal}
          />

          {/* ------ Product Series Modal ------ */}
          <ProductUbicacionSeriesModal
            open={openSeriesModal}
            setOpen={setOpenSeriesModal}
          />
        </Grid>
      </>
    );
  };

export default EquiposUtilizadosInstallOTTecAsig;
